import Component from "./Developer";
export default Component;
